import { styled } from "@material-ui/core/styles";
import React from "react";
// import { Link } from "gatsby";
import { LocalizedLink as Link } from "gatsby-theme-i18n";
import theme from "../../theme";

const MyLink = styled(Link)({
  textDecoration: "none",
  color: theme.palette.text.primary,
  fontWeight: "bold",
});

const MyCustomLink = styled("a")({
  textDecoration: "none",
  color: theme.palette.text.primary,
  fontWeight: "bold",
});

export default ({ href, ...rest }) => {
  return href ? <MyCustomLink to="" href={href} {...rest} /> : <MyLink to="" {...rest} />;
};
